// extracted by mini-css-extract-plugin
export default {"company":"ChooseCustomer_company__xtfcY"};